import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useMemberStore = defineStore('member', () => {
    const all = ref({ data: [] });

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/members', { params });
    };

    const store = (formData) => {
        return axios.post('/api/v1/members', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    };

    const update = (formData) => {
        return axios.post('/api/v1/members/' + formData.get('hash'), formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/members/' + params.hash);
    };

    return {
        all,
        reset,
        search,
        store,
        update,
        destroy,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMemberStore, import.meta.hot));
}
